import { ofetch } from 'ofetch'
import useGlobalStore from '@/useGlobalStore.ts'
import { dispatch } from '@/useBus.ts'
import usePreferences from '@/usePreferences.ts'
import { toast } from 'sonner'
import { Capacitor } from '@capacitor/core'

const sharedHeaders = {
	// @ts-ignore
	// 'Content-Type': 'application/json',
	Accept: 'application/json',
}

const api = ofetch.create({
	baseURL: `${import.meta.env.VITE_API_URL}`,
	async onRequest({ request, options }) {
		if (!useGlobalStore.getState().isNetworkOnline) {
			toast('No internet connection, try again later')
			options.retry = 0
			return
		}

		// If method is POST, PUT, PATCH, DELETE => set retry = 0
		const method = (options.method || 'GET').toUpperCase()
		if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
			options.retry = 0
		}
		// @ts-ignore
		const appAuthToken = window.tempAppAuthToken ?? useGlobalStore.getState().user?.access_token
		// passed headers in the options.headers are not passed, not sure why, so this is a hack
		const passedHeaders =
			options.params?.headers !== undefined && options.params?.headers !== null ? options.params?.headers : {}
		if (options.params !== null) {
			delete options.params?.headers
		}
		const locale = useGlobalStore.getState().appLanguageCode
		if (locale !== null && locale !== '') {
			passedHeaders['X-Accept-Language'] = locale
		}
		// @ts-ignore
		sharedHeaders['X-App-Version'] = useGlobalStore.getState().appVersion
		// @ts-ignore
		sharedHeaders['X-App-Platform'] = Capacitor.getPlatform()
		options.headers = new Headers({ ...options.headers, ...sharedHeaders, ...passedHeaders })
		if (!['/auth/login', '/auth/register', '/auth/google/callback'].includes(request as string)) {
			options.headers.set('Authorization', `Bearer ${appAuthToken}`)
		}
	},
	retry: 5, // except on POST, PUT, PATCH, DELETE
	retryDelay: 800, // ms
	async onResponse(context) {
		const { response, options, request } = context
		// Disable retry for specific status codes
		if ([429].includes(response.status)) {
			options.retry = 0
		}
		if (response.status === 419) {
			const { access_token } = await ofetch(`${import.meta.env.VITE_API_URL}/auth/refresh-access-token`, {
				method: 'POST',
				headers: {
					...sharedHeaders,
					Authorization: `Bearer ${useGlobalStore.getState().user?.refresh_token}`,
				},
			}).catch(() => {
				dispatch('show-auth-dialog')
			})

			await usePreferences.getState().setItem('appAuthToken', access_token)
			// useGlobalStore.getState().setAppToken('appAuthToken', access_token)
			// @ts-ignore
			window.tempAppAuthToken = access_token

			await api(request, {
				...options,
				onResponse(ctx) {
					Object.assign(context, ctx)
				},
			})
		} else if (response.status === 401) {
			dispatch('show-auth-dialog')
		} else if (response.status === 402) {
			dispatch('toggle-purchase-subscription-dialog', {
				val: true,
				mode: '',
			})
		}
	},
})

export default api
